"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrency = void 0;
const currency_formatter_1 = require("currency-formatter");
const locale_currency_1 = require("locale-currency");
const react_1 = require("react");
const react_2 = require("react");
const countries_1 = require("../countries");
const currency_1 = require("../currency");
const LocalizationProvider_1 = require("./LocalizationProvider");
function useCurrency() {
    var _a, _b;
    const { country: countryCode } = (0, react_2.useContext)(LocalizationProvider_1.LocalizationContext);
    if (typeof countryCode !== 'string') {
        throw 'Missing context. Did you wrap your component in LocalizationProvider?';
    }
    const country = (0, countries_1.getCountry)(countryCode);
    const currency = country.currency.split(',')[0];
    const thousandsSeparator = (_a = (0, currency_formatter_1.findCurrency)(currency)) === null || _a === void 0 ? void 0 : _a.thousandsSeparator;
    const decimalSeparator = (_b = (0, currency_formatter_1.findCurrency)(currency)) === null || _b === void 0 ? void 0 : _b.decimalSeparator;
    const currencySymbol = (0, react_2.useMemo)(() => {
        var _a;
        return (_a = (0, currency_formatter_1.findCurrency)(currency.length === 2 ? (0, locale_currency_1.getCurrency)(currency) : currency)) === null || _a === void 0 ? void 0 : _a.symbol;
    }, [currency]);
    const formatMethod = (0, react_2.useMemo)(() => (value) => (0, currency_1.formatCurrency)(value, currency), [currency]);
    const appendCurrencyMethod = (0, react_2.useMemo)(() => (value) => (0, currency_1.appendCurrency)(value, currency), [currency]);
    const unAppendCurrencyMethod = (0, react_2.useMemo)(() => (value) => (0, currency_1.unAppendCurrency)(value, currency), [currency]);
    const unFormatCurrencyMethod = (0, react_1.useCallback)((value) => (0, currency_1.unFormatCurrency)(value, currency), [currency]);
    const formatMoneyValueMethod = (0, react_1.useCallback)((value) => (0, currency_1.formatMoneyValue)(value, currency), [currency]);
    return {
        currency,
        currencySymbol,
        thousandsSeparator,
        decimalSeparator,
        formatCurrency: formatMethod,
        appendCurrency: appendCurrencyMethod,
        unAppendCurrency: unAppendCurrencyMethod,
        unFormatCurrency: unFormatCurrencyMethod,
        formatMoneyValue: formatMoneyValueMethod,
    };
}
exports.useCurrency = useCurrency;
//# sourceMappingURL=useCurrency.js.map